import React from 'react';
import {Redirect} from 'react-router-dom';
import {makeStyles} from '@material-ui/core';
import ProductOptionGroupsList from './ProductOptionGroupsList';
import {useIsFeatureInTier} from '../../../utils/component';
import FeatureAccessOverlay from '../../entitlement/components/feature-access-overlay';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    background: '#f8f9fb',
  },
  content: {
    flex: 1,
    width: '100%',
    maxWidth: 1200,
    margin: '0 auto',
    position: 'relative',
    padding: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
  },
}));

export default function ProductOptionPage() {
  const classes = useStyles();

  const hasOptionFeature = useIsFeatureInTier('PRODUCT_OPTIONS');

  if (!hasOptionFeature) {
    return <Redirect to="/404" />;
  }

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <FeatureAccessOverlay feature="PRODUCT_OPTIONS" />
        <ProductOptionGroupsList />
      </div>
    </div>
  );
}
